import { useState } from 'react';
import Modal from './Modal';
import UserAvatar from './UserAvatar';
import FormField from './shared/FormField';
import { CheckIcon } from './Icons';
import { PROJECT_TYPE_CONFIG } from '../constants';

export default function CreateProjectModal({ onClose, onCreate, users }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('scrum');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const toggleMember = (uid) => {
    setSelectedMembers((prev) =>
      prev.includes(uid) ? prev.filter((id) => id !== uid) : [...prev, uid]
    );
  };

  const handleSubmit = async () => {
    if (!name.trim() || submitting) return;
    setSubmitting(true);
    try {
      await onCreate({ name: name.trim(), description: description.trim(), type, members: selectedMembers });
      onClose();
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Create Project"
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={!name.trim() || submitting}>
            Create Project
          </button>
        </>
      }
    >
      <div className="add-item-form">
        <FormField label="Project Name">
          <input
            className="form-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Website Redesign"
            autoFocus
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
        </FormField>
        <FormField label="Description (optional)">
          <textarea
            className="form-input"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Brief project description"
            rows={2}
          />
        </FormField>
        <FormField label="Board Type">
          <div className="project-type-selector">
            {Object.entries(PROJECT_TYPE_CONFIG).map(([key, cfg]) => (
              <div
                key={key}
                className={`project-type-option ${type === key ? 'selected' : ''}`}
                onClick={() => setType(key)}
              >
                <strong>{cfg.label}</strong>
                <span>{cfg.description}</span>
              </div>
            ))}
          </div>
        </FormField>
        <FormField label="Add Members">
          <div className="project-member-picker">
            {users.map((u) => {
              const selected = selectedMembers.includes(u.uid);
              return (
                <div
                  key={u.uid}
                  className={`project-member-option ${selected ? 'selected' : ''}`}
                  onClick={() => toggleMember(u.uid)}
                >
                  <UserAvatar user={u} size={32} showStatus={false} />
                  <span className="project-member-option-name">{u.displayName}</span>
                  {selected && <CheckIcon size={14} />}
                </div>
              );
            })}
          </div>
        </FormField>
      </div>
    </Modal>
  );
}
